import { NgModule, ModuleWithProviders } from '@angular/core';
import {
  MdlTooltipComponent, MdlSimpleTooltipComponent
} from './mdl-tooltip.component';

import {
  MdlTooltipDirective,
  MdlTooltipLargeDirective
} from './mdl-tooltip.directive';

const MDL_TOOLTIP_DIRECTIVES = [
  MdlTooltipComponent,
  MdlTooltipLargeDirective,
  MdlTooltipDirective
];

export * from './mdl-tooltip.component';
export * from './mdl-tooltip.directive';


export class MdlTooltipModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: MdlTooltipModule,
      providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  exports: MDL_TOOLTIP_DIRECTIVES,
  declarations: [...MDL_TOOLTIP_DIRECTIVES, MdlSimpleTooltipComponent ],
  entryComponents: [MdlSimpleTooltipComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
